import './style.css';
import '../../tokens/index.css';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { initTheme } from '@lumi/ui';
import { installChunkReloadRecovery, registerAppKitI18n, syncHtmlLang } from '@lumi/app-kit';
import router from './router';
import App from './App.vue';
import { i18n } from './i18n';

// Sync the colour theme (data-theme on <html>) with the reactive ref the shared
// components bind to. The index.html pre-paint script already applied it; this
// reconciles + persists any ?theme= handoff.
initTheme();

const app = createApp(App);
app.use(createPinia());
// A tab left open across a deploy no longer has the lazy chunks its build
// references; recover before the first navigation instead of dying silently.
installChunkReloadRecovery(router);
app.use(router);
app.use(i18n);
registerAppKitI18n(i18n.global);
// Issue 508: keeps <html lang> in step with the active i18n locale so native
// date/datetime-local pickers (no shared component; see uiLocale.ts) pick up the
// same locale everywhere the browser honours it.
syncHtmlLang(i18n.global.locale);
app.mount('#app');
